import React from 'react';

const ArchiveTab = () => <div>ArchiveTab</div>;

export default ArchiveTab;
